import { render, staticRenderFns } from "./AgregarBmat.vue?vue&type=template&id=eabb2452"
import script from "./AgregarBmat.vue?vue&type=script&lang=js"
export * from "./AgregarBmat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports